import React from 'react'
import { useDispatch } from 'react-redux'
import styles from '../ProlisterGrid.module.scss'
import type { IItem } from '../../Items/IItem'
import Button from '../../Components/Button'
import { openEditCategoryModal } from '../../UI/UI.reducer'
import { getCategoryTree } from '../../Infrastructure/Helpers/categoryHelper'
import { isItemPublished } from '../../List/helpers'

interface CategoryRendererProps {
  data: IItem
}

const CategoryRenderer: React.FunctionComponent<CategoryRendererProps> = ({
  data,
}) => {
  const dispatch = useDispatch()
  const categoryName = data.category ? getCategoryTree(data.category) : ''
  return (
    <div className={`${styles.selecter}`}>
      <Button
        testId="create-itemchanges"
        clickHandler={() => dispatch(openEditCategoryModal(data.id ?? ''))}
        size="small"
        disable={isItemPublished(data?.publishResult)}
        content={
          <p
            style={{
              direction: 'rtl',
              textAlign: 'left',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
            }}
          >
            {categoryName}
          </p>
        }
        variant="action"
      />
    </div>
  )
}

export default CategoryRenderer
